import { MinzeElement } from 'minze'

export class TjPrevSlideIcon extends MinzeElement {
  html = () => `<svg width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M7.50994 13.2628L8.78835 11.9986L4.34943 7.55966H15.5V5.71307H4.34943L8.78835 1.28125L7.50994 0.00994253L0.883523 6.63636L7.50994 13.2628Z" fill="white"/>
  </svg>
  `
}